import React, {useMemo} from 'react';
import {LatLng} from 'leaflet';
import {useTranslation} from 'react-i18next';
import {
	useRootContextMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/context/rootContext/hooks/useRootContextMutateSingleVoyage";
import {
	useRebuildPointsAndPositionsMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/points/hooks/useRebuildPointsAndPositionsMutateSingleVoyage";
import {useMapFeaturesContext} from "@ui/leafletCustom/context/mapContext/hooks/useMapFeaturesContext";
import {getLatLngFromPointGeomCoordinates} from "@helpers/geoJson/getLatLngFromPointGeomCoordinates";
import {getRandomNumber} from "@helpers/number/getRandomNumber";
import {IWayPointCreationWithCorrectionsSingleVoyage} from "@containers/singleVoyage/types/point";
import {IPointTemplatesSingleVoyage} from "@containers/singleVoyage/pointTemplates/types";
import SelectPointTemplateSearch
	from "@containers/singleVoyage/pointTemplates/select/selectPointTemplate/SelectPointTemplateSearch";

const SearchPointsFromPastVoyagesMutateSingleVoyage = () => {

	const {t} = useTranslation()

	const {mapFeatures} = useMapFeaturesContext()

	const {
		points,
		setTargetPointId,
		accountId,
	} = useRootContextMutateSingleVoyage()

	const {onRebuild} = useRebuildPointsAndPositionsMutateSingleVoyage()

	// nearest to the last stop first - that is almost always what the next stop should be
	const origin = useMemo(() => {
		const lastPoint = points?.[points.length - 1]
		if (!lastPoint) {
			return null
		}
		return getLatLngFromPointGeomCoordinates(lastPoint.geom)
	}, [points])

	const handleChange = async (value: string, point: IPointTemplatesSingleVoyage) => {
		const newPoint: IWayPointCreationWithCorrectionsSingleVoyage = {
			address: point.address,
			geom: point.geom,
			correctionWaypoints: [],
			name: point.name,
			plannedArrival: null,
			plannedDeparture: null,
			plannedOrdinal: 0,
			radius: point.radius,
			type: point.type === 'RFID' ? 'RFID_POINT' : 'POINT_RADIUS',
			shapeOrdinal: 0,
			id: getRandomNumber(),
			status: 'PLANNED',
			waypointTemplateId: point.id,
		}

		await onRebuild({
			points: [
				...points,
				newPoint
			]
		})

		setTargetPointId(newPoint?.id?.toString())

		if (mapFeatures) {
			const {lat, lng} = getLatLngFromPointGeomCoordinates(newPoint.geom)
			mapFeatures.setView(new LatLng(lat, lng), 17)
		}
	}

	return (
		<SelectPointTemplateSearch
			accountId={Number(accountId)}
			onChange={handleChange}
			origin={origin}
			label={t('singleVoyage.searchPoints')}
		/>
	);
};

export default SearchPointsFromPastVoyagesMutateSingleVoyage;
